/* =====================================================================
   Heilwissen Akademie · Chat-Widget  (selbst-injizierend, 1 Script-Tag)
   Einbau:  <script src="…/heilwissen-chat.js" defer></script>
   Marke:   beige/gold · Poppins · warme Shadows  (hwa-design-system)
   Backend: Live-n8n chatTrigger (öffentlich, CORS spiegelt Origin)
   Motion:  ease-out-expo, reduced-motion-safe (Jakub/Emil-Lens, E-Commerce)
   Features: 2 Personas · echte Produktkarten · Streaming-Reveal · Persistenz
             · Neu-starten · Fragen-Teaser (Eingabefeld-Optik) · Follow-ups
             · Scroll-to-bottom · Esc/Focus-A11y · Bild-Zoom · Retry
   ===================================================================== */
(function(){
  "use strict";
  if(window.__hwaChatLoaded) return;
  // --- Sichtbarkeits-Gate (für „erstmal nur für mich"): nur laden, wenn freigeschaltet ---
  // Einbau setzt window.HWA_GATED=true → Widget erscheint NUR, wenn die Seite einmal mit
  // ?jchat=1 aufgerufen wurde (Flag bleibt in localStorage). Abschalten: ?jchat=0.
  if(window.HWA_GATED){
    try{var sp=new URLSearchParams(location.search);
      if(sp.get('jchat')==='1')localStorage.setItem('hwa-chat-on','1');
      if(sp.get('jchat')==='0')localStorage.removeItem('hwa-chat-on');
      if(localStorage.getItem('hwa-chat-on')!=='1')return;
    }catch(e){return;}
  }
  window.__hwaChatLoaded=true;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Welche Personas im Widget? Website = nur „Assistent" (Rainer-Stimme lebt im E-Mail-System).
  var PERSONA_ORDER = (window.HWA_PERSONAS && window.HWA_PERSONAS.length) ? window.HWA_PERSONAS : ['assistant'];
  // Fragen-Teaser am Launcher (Eingabefeld-Optik, Wunsch Rainer 03.07.) — Text per
  // window.HWA_LAUNCHER_LABEL überschreibbar; leerer String ('') schaltet ihn aus.
  var LAUNCHER_LABEL = (typeof window.HWA_LAUNCHER_LABEL==='string') ? window.HWA_LAUNCHER_LABEL
    : 'Hier kannst du alle Fragen zur Website und zu allen Kursen stellen';

  // ---------- Konfiguration ----------
  var ENDPOINTS={
    assistant:"https://hwa-n8n.site/webhook/heilwissen-chat/chat",
    rainer:   "https://hwa-n8n.site/webhook/heilwissen-chat-rainer/chat"
  };
  var FEEDBACK_URL="https://hwa-n8n.site/webhook/heilwissen-chat-feedback";
  var SUN="https://heilwissen-akademie.de/wp-content/uploads/2025/04/HWA_Logo_Teil1.svg";
  var RAINER_IMG="https://heilwissen-akademie.de/wp-content/uploads/2025/12/IMG_20240527_173711-scaled-e1765058773623.jpg";
  var PERSONA={
    assistant:{
      name:"Heilwissen Akademie Bot", status:"KI-Assistent, antwortet sofort", typing:"schreibt", typingName:"Heilwissen Bot", ava:SUN, sun:true,
      greet:"Hallo! 🌿 Ich bin der KI-Assistent der Heilwissen Akademie. Ich helfe dir direkt bei Fragen zu Kursen, Ausbildungen, Produkten und Bestellungen.\n\nWomit kann ich dir helfen?",
      quick:["Welche Seminare gibt es?","Omega-3-Produkte","Therapeuten finden","Was sind die 5 Naturgesetze?"],
      suggest:["Preise & Pakete","Kostenfreier Live-Abend","Wann ist die nächste Yogawoche?"]
    },
    rainer:{
      name:"Rainer Körner", status:"KI-Assistent, antwortet in Rainers Worten", typing:"tippt", ava:RAINER_IMG, sun:false,
      greet:"Hallo, schön dass Du da bist! 🍀 Ich bin Rainer.\n\nFrag mich einfach alles rund ums BioLogische Heilwissen, meine Seminare oder welcher Weg für Dich passt — ich helf Dir gern weiter.",
      quick:["Wie fange ich am besten an?","Erzähl mir von der KTT","Welcher Kurs passt zu mir?","Was ist BioLogisches Heilwissen?"],
      suggest:["Welcher Kurs passt zu mir?","Erzähl mir von der KTT","Kann ich Dich erreichen?"]
    }
  };

  // ---------- Font ----------
  if(!document.querySelector('link[data-hwa-font]')){
    var l=document.createElement('link'); l.rel='stylesheet'; l.setAttribute('data-hwa-font','');
    l.href='https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,500;1,600&display=swap';
    document.head.appendChild(l);
  }

  // ---------- Styles ----------
  var CSS=`
  .hwa-w{--beige:#ece7df;--beige-2:#f4f0e8;--gold:#deb54e;--gold-d:#c9a444;--gold-link:#8f6e15;--gold-soft:#f7edd5;
    --ink:#2b2b2b;--ink-2:#5c574e;--line:#e4dccb;--green:#7fa64e;--green-d:#5f7d37;
    --exp:cubic-bezier(.16,1,.3,1);--exp2:cubic-bezier(.22,1,.36,1);
    --sh-soft:0 6px 22px rgba(60,45,15,.10);--sh-card:0 12px 34px rgba(60,45,15,.16);
    font-family:'Poppins',-apple-system,Segoe UI,Arial,sans-serif}
  .hwa-w *{box-sizing:border-box}
  .hwa-w button:focus-visible,.hwa-w textarea:focus-visible,.hwa-w a:focus-visible{outline:2px solid var(--gold-d);outline-offset:2px}

  .hwa-launcher{position:fixed;right:26px;bottom:var(--hwa-b,26px);width:76px;height:76px;border-radius:50%;border:none;cursor:pointer;
    background:radial-gradient(circle at 32% 28%,#f3d27e 0%,var(--gold) 56%,var(--gold-d) 100%);
    box-shadow:0 10px 28px rgba(222,181,78,.5);display:flex;align-items:center;justify-content:center;z-index:2147483000;
    transition:transform .4s var(--exp),box-shadow .4s var(--exp),bottom .3s var(--exp)}
  .hwa-launcher:hover{transform:translateY(-4px) scale(1.05);box-shadow:0 14px 38px rgba(222,181,78,.62)}
  .hwa-launcher:active{transform:translateY(-1px) scale(.99)}
  .hwa-launcher svg{width:37px;height:37px;flex-shrink:0;transition:transform .4s var(--exp)}
  .hwa-launcher:hover svg{transform:rotate(-8deg)}
  .hwa-launcher .pulse{position:absolute;inset:0;border-radius:50%;animation:hwaPulse 2.8s var(--exp) infinite}
  @keyframes hwaPulse{0%{box-shadow:0 0 0 0 rgba(222,181,78,.5)}70%{box-shadow:0 0 0 17px rgba(222,181,78,0)}100%{box-shadow:0 0 0 0 rgba(222,181,78,0)}}
  .hwa-launcher .badge{position:absolute;top:-2px;right:-2px;min-width:22px;height:22px;padding:0 6px;border-radius:50px;background:#d9534a;
    color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center;border:2px solid #fff}
  .hwa-open .hwa-launcher{transform:scale(0) rotate(-25deg);pointer-events:none;opacity:0}
  /* Bottom-Abstand kommt aus --hwa-b (JS setzt ihn: Basis, Sticky-Warenkorb im Shop, Cookie-Button) */

  /* Kleines Kreuz an der Schulter des Launchers: stellt den Chat dauerhaft in die Ecke.
     Bewusst immer sichtbar statt nur beim Ueberfahren mit der Maus - auf einem Tastbildschirm
     gibt es kein Ueberfahren, und wer den Chat wegstellen will, muss den Knopf finden koennen. */
  .hwa-park{position:fixed;right:20px;bottom:calc(var(--hwa-b,26px) + 58px);width:24px;height:24px;border-radius:50%;
    background:#fff;border:1px solid var(--line);color:#8a8378;font-size:14px;line-height:1;cursor:pointer;padding:0;
    display:flex;align-items:center;justify-content:center;box-shadow:var(--sh-soft);opacity:.72;z-index:2147483002;
    transition:opacity .25s var(--exp),transform .25s var(--exp),bottom .3s var(--exp)}
  .hwa-park:hover{opacity:1;transform:scale(1.12)}
  .hwa-open .hwa-park{display:none}

  /* Ruhemodus: der Besucher hat den Chat bewusst in die Ecke gestellt. Der Chat bleibt
     erreichbar, nimmt aber nur noch einen kleinen Punkt ein - kein Teaser, kein Pulsieren. */
  .hwa-ruhe .hwa-launcher{width:40px;height:40px;opacity:.7;box-shadow:0 4px 12px rgba(222,181,78,.36)}
  .hwa-ruhe .hwa-launcher:hover{opacity:1}
  .hwa-ruhe .hwa-launcher svg{width:20px;height:20px}
  .hwa-ruhe .hwa-launcher .pulse{display:none}
  .hwa-ruhe .hwa-park{display:none}
  .hwa-ruhe .hwa-lab,.hwa-ruhe .hwa-tip{display:none !important}

  /* Flache Fenster (kleines Notebook, Handy quer): grosser Launcher plus Teaser frisst zu viel Bild. */
  @media (max-height:640px){
    .hwa-launcher{width:60px;height:60px}.hwa-launcher svg{width:29px;height:29px}
    .hwa-park{bottom:calc(var(--hwa-b,26px) + 44px)}
    .hwa-lab,.hwa-tip{display:none}
  }

  .hwa-tip{position:fixed;right:114px;bottom:calc(var(--hwa-b,26px) + 12px);max-width:230px;background:#fff;color:var(--ink);border-radius:16px;
    padding:12px 15px;font-size:.86rem;line-height:1.5;box-shadow:var(--sh-card);z-index:2147483000;cursor:pointer;
    transform:translateX(8px) scale(.96);opacity:0;pointer-events:none;transition:transform .45s var(--exp),opacity .35s var(--exp);transform-origin:bottom right}
  .hwa-tip.show{transform:none;opacity:1;pointer-events:auto}
  .hwa-tip::after{content:"";position:absolute;right:-7px;bottom:20px;width:14px;height:14px;background:#fff;transform:rotate(45deg)}
  .hwa-tip b{color:var(--gold-d)}
  .hwa-tip .x{position:absolute;top:6px;right:9px;color:#bbb;font-size:14px;line-height:1}

  .hwa-lab{position:fixed;right:114px;bottom:calc(var(--hwa-b,26px) + 12px);width:min(324px,calc(100vw - 170px));
    background:#fff;border:1.5px solid var(--line);border-radius:27px;padding:14px 58px 14px 20px;
    font-size:.95rem;font-weight:500;line-height:1.45;color:#6b655a;box-shadow:var(--sh-card);z-index:2147482999;
    cursor:pointer;opacity:0;pointer-events:none;transform:translateX(14px) scale(.9);transform-origin:bottom right;
    transition:transform .55s cubic-bezier(.34,1.56,.64,1),opacity .35s var(--exp),bottom .3s var(--exp)}
  .hwa-lab.show{opacity:1;pointer-events:auto;transform:none}
  .hwa-lab .go{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:40px;height:40px;border-radius:50%;
    background:linear-gradient(135deg,var(--gold),var(--gold-d));box-shadow:0 3px 11px rgba(222,181,78,.45);
    display:flex;align-items:center;justify-content:center}
  .hwa-lab .go svg{width:19px;height:19px;flex-shrink:0}
  .hwa-lab .x{position:absolute;top:-9px;right:-7px;width:22px;height:22px;border-radius:50%;background:#fff;
    border:1px solid var(--line);color:#9b9488;font-size:13px;line-height:20px;text-align:center;box-shadow:var(--sh-soft)}
  .hwa-open .hwa-lab{display:none}
  /* Warenkorb offen bzw. Warenkorb-/Kassenseite: Widget komplett weg. Launcher und Teaser lagen mobil
     ueber dem "Zur Kasse"-Button des Kaching-Drawers, ein Tipp darauf oeffnete den Chat statt zu bezahlen. */
  html.kaching-body__cart-open .hwa-w,
  body.kaching-body__cart-open .hwa-w,
  body.template-cart .hwa-w,
  html.hwa-nocart .hwa-w{display:none !important}

  .hwa-widget{position:fixed;right:26px;bottom:26px;width:416px;max-width:calc(100vw - 32px);height:648px;
    max-height:calc(100vh - 48px);background:var(--beige);border-radius:24px;overflow:hidden;
    box-shadow:0 28px 70px rgba(40,30,10,.30);z-index:2147483001;display:flex;flex-direction:column;
    transform:translateY(26px) scale(.92);transform-origin:bottom right;opacity:0;pointer-events:none;
    transition:transform .46s var(--exp),opacity .34s var(--exp)}
  .hwa-open .hwa-widget{transform:none;opacity:1;pointer-events:auto}

  .hwa-head{background:linear-gradient(135deg,#fff 0%,#fdfbf6 100%);border-bottom:1px solid var(--line);padding:15px 16px 13px;position:relative;flex-shrink:0;z-index:3}
  .hwa-head-top{display:flex;align-items:center;gap:12px}
  .hwa-avatar{width:46px;height:46px;border-radius:50%;flex-shrink:0;object-fit:cover;background:var(--gold-soft);
    border:2px solid var(--gold);box-shadow:0 3px 12px rgba(222,181,78,.4);transition:opacity .35s var(--exp)}
  .hwa-avatar.sun{padding:7px;object-fit:contain;background:radial-gradient(circle at 35% 30%,#fbf0d4,#f3e2b4)}
  .hwa-head-meta{flex:1;min-width:0}
  .hwa-head-meta h3{margin:0;font-size:1.02rem;font-weight:700;line-height:1.2;color:var(--ink)}
  .hwa-head-meta .status{display:flex;align-items:center;gap:6px;font-size:.78rem;color:var(--ink-2);margin-top:2px}
  .hwa-head-meta .dot{width:8px;height:8px;border-radius:50%;background:var(--green);box-shadow:0 0 0 3px rgba(127,166,78,.28)}
  .hwa-actions{display:flex;gap:4px;flex-shrink:0}
  .hwa-iconbtn{width:32px;height:32px;border:1px solid rgba(49,49,49,.10);background:rgba(49,49,49,.06);border-radius:50%;cursor:pointer;color:var(--ink-2);
    display:flex;align-items:center;justify-content:center;transition:background .25s var(--exp),transform .3s var(--exp)}
  .hwa-iconbtn:hover{background:rgba(49,49,49,.12)}
  .hwa-iconbtn svg{width:17px;height:17px;min-width:17px;flex-shrink:0}  /* flex-shrink:0 = Pflicht: WP/Elementor-Seiten nehmen der SVG die intrinsische Breite → schrumpft sonst auf 0 */
  .hwa-iconbtn svg path{stroke:#57524a !important}  /* explizit statt nur currentColor: Host-CSS mancher Seiten färbt Button-Text weiß → Icons wären weiß-auf-weiß */
  #hwaClose:hover{transform:rotate(90deg)}
  #hwaRestart:hover svg{transform:rotate(-40deg);transition:transform .4s var(--exp)}

  .hwa-persona{display:flex;gap:5px;margin-top:12px;background:var(--beige);padding:4px;border-radius:50px;position:relative}
  .hwa-persona button{flex:1;border:none;background:transparent;font-family:inherit;font-weight:600;font-size:.82rem;
    color:var(--ink-2);padding:8px 10px;border-radius:50px;cursor:pointer;z-index:1;display:flex;align-items:center;
    justify-content:center;gap:6px;transition:color .35s var(--exp)}
  .hwa-persona button.active{color:#fff}
  .hwa-persona .pill{position:absolute;top:4px;bottom:4px;left:4px;width:calc(50% - 6px);border-radius:50px;
    background:linear-gradient(135deg,var(--gold),var(--gold-d));box-shadow:0 4px 12px rgba(222,181,78,.42);transition:transform .46s var(--exp2);z-index:0}
  .hwa-persona[data-p="rainer"] .pill{transform:translateX(calc(100% + 4px));background:linear-gradient(135deg,#86ad53,var(--green-d));box-shadow:0 4px 12px rgba(95,125,55,.42)}
  .hwa-persona .ava{width:18px;height:18px;border-radius:50%;object-fit:cover}

  .hwa-scroll{position:relative;flex:1;min-height:0;display:flex;flex-direction:column}
  .hwa-msgs{flex:1;min-height:0;overflow-y:auto;overflow-x:hidden;padding:18px 16px 8px;display:flex;flex-direction:column;gap:13px;overscroll-behavior:contain}
  .hwa-row{min-width:0;max-width:100%}
  .hwa-msgs::-webkit-scrollbar{width:7px}.hwa-msgs::-webkit-scrollbar-thumb{background:rgba(0,0,0,.13);border-radius:10px}
  .hwa-row{display:flex;gap:9px;align-items:flex-end;animation:hwaIn .42s var(--exp) both}
  @keyframes hwaIn{from{opacity:0;transform:translateY(11px)}to{opacity:1;transform:none}}
  .hwa-row.user{flex-direction:row-reverse}
  .hwa-row .mava{width:30px;height:30px;border-radius:50%;flex-shrink:0;object-fit:cover;background:var(--gold-soft);border:1.5px solid var(--gold)}
  .hwa-row .mava.sun{padding:4px;object-fit:contain}
  .hwa-bubble{max-width:80%;padding:11px 14px;border-radius:17px;font-size:.92rem;line-height:1.62;box-shadow:0 2px 9px rgba(60,45,15,.06);word-wrap:break-word;color:var(--ink)}
  .hwa-row.bot .hwa-bubble{background:#fff;border-bottom-left-radius:5px}
  .hwa-row.user .hwa-bubble{background:linear-gradient(135deg,var(--gold),var(--gold-d));color:#fff;border-bottom-right-radius:5px;box-shadow:0 4px 14px rgba(222,181,78,.42)}
  .hwa-bubble a{color:var(--gold-link);font-weight:600;text-decoration:none;border-bottom:1px solid rgba(143,110,21,.5)}
  .hwa-row.user .hwa-bubble a{color:#fff;border-bottom-color:rgba(255,255,255,.6)}
  .hwa-bubble p{margin:0 0 8px}.hwa-bubble p:last-child{margin:0}
  .hwa-bubble ul{margin:6px 0;padding-left:18px}.hwa-bubble li{margin:3px 0}.hwa-bubble strong{font-weight:700}
  .hwa-caret{display:inline-block;width:2px;height:1em;background:var(--gold);margin-left:1px;vertical-align:-2px;animation:hwaCaret .8s steps(1) infinite}
  @keyframes hwaCaret{50%{opacity:0}}

  .hwa-products{display:flex;gap:11px;overflow-x:auto;padding:5px 2px 11px;margin:-2px 0 2px;scroll-snap-type:x mandatory;overscroll-behavior-x:contain}
  .hwa-products::-webkit-scrollbar{height:6px}.hwa-products::-webkit-scrollbar-thumb{background:rgba(0,0,0,.13);border-radius:10px}
  .hwa-pcard{flex:0 0 170px;scroll-snap-align:start;background:#fff;border-radius:15px;overflow:hidden;
    box-shadow:var(--sh-soft);display:flex;flex-direction:column;border:1px solid var(--line);
    transition:transform .34s var(--exp),box-shadow .34s var(--exp);animation:hwaPop .5s var(--exp2) both}
  @keyframes hwaPop{from{opacity:0;transform:translateY(14px) scale(.96)}to{opacity:1;transform:none}}
  .hwa-pcard:hover{transform:translateY(-6px);box-shadow:var(--sh-card)}
  .hwa-pcard .pimg{width:100%;height:122px;background:var(--beige-2);position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center}
  .hwa-pcard .pimg img{width:100%;height:100%;object-fit:contain;padding:8px;transition:transform .5s var(--exp)}
  .hwa-pcard:hover .pimg img{transform:scale(1.07)}
  .hwa-pcard .pprice{position:absolute;top:8px;right:8px;background:rgba(255,255,255,.96);color:var(--ink);font-weight:700;font-size:.8rem;padding:4px 10px;border-radius:50px;box-shadow:0 2px 7px rgba(0,0,0,.13)}
  .hwa-pcard .pbody{padding:11px 12px 13px;display:flex;flex-direction:column;flex:1}
  .hwa-pcard .ptitle{font-size:.84rem;font-weight:600;line-height:1.35;margin:0 0 11px;color:var(--ink);
    display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.3em}
  .hwa-pcard .pbtn{margin-top:auto;text-align:center;background:var(--gold);color:#fff;font-weight:600;font-size:.8rem;
    padding:9px;border-radius:50px;text-decoration:none;box-shadow:0 3px 11px rgba(222,181,78,.42);transition:transform .26s var(--exp),background .26s var(--exp)}
  .hwa-pcard .pbtn:hover{background:var(--gold-d);transform:translateY(-2px)}

  .hwa-typing{display:flex;align-items:center;gap:8px}
  .hwa-typing .dots{display:flex;gap:4px;padding:13px 15px;background:#fff;border-radius:17px;border-bottom-left-radius:5px;box-shadow:0 2px 9px rgba(60,45,15,.06)}
  .hwa-typing .dots span{width:7px;height:7px;border-radius:50%;background:var(--gold);opacity:.5;animation:hwaTyp 1.2s var(--exp) infinite}
  .hwa-typing .dots span:nth-child(2){animation-delay:.18s}.hwa-typing .dots span:nth-child(3){animation-delay:.36s}
  .hwa-typing .lbl{font-size:.74rem;color:var(--ink-2)}
  @keyframes hwaTyp{0%,60%,100%{transform:translateY(0);opacity:.4}30%{transform:translateY(-5px);opacity:1}}

  .hwa-tobottom{position:absolute;right:14px;bottom:10px;width:34px;height:34px;border-radius:50%;border:1px solid var(--line);
    background:#fff;color:var(--gold-d);cursor:pointer;box-shadow:var(--sh-soft);display:flex;align-items:center;justify-content:center;
    opacity:0;transform:translateY(8px) scale(.9);pointer-events:none;transition:opacity .3s var(--exp),transform .3s var(--exp);z-index:4}
  .hwa-tobottom.show{opacity:1;transform:none;pointer-events:auto}
  .hwa-tobottom svg{width:16px;height:16px;flex-shrink:0}

  .hwa-quick{display:flex;flex-wrap:wrap;gap:7px;padding:2px 16px 10px}
  .hwa-quick:empty{display:none}
  .hwa-chip{border:1px solid var(--gold);background:rgba(255,255,255,.72);color:var(--gold-d);font-family:inherit;
    font-weight:500;font-size:.8rem;padding:7px 13px;border-radius:50px;cursor:pointer;animation:hwaIn .4s var(--exp) both;
    transition:background .26s var(--exp),color .26s var(--exp),transform .26s var(--exp)}
  .hwa-chip:hover{background:var(--gold);color:#fff;transform:translateY(-2px)}

  .hwa-fb{display:flex;align-items:center;gap:7px;padding:0 0 2px 39px;animation:hwaIn .4s var(--exp) both}
  .hwa-fb-q{font-size:.76rem;color:var(--ink-2)}
  .hwa-fb-btn{border:1px solid var(--line);background:#fff;border-radius:50px;min-width:32px;height:28px;cursor:pointer;
    font-size:.92rem;line-height:1;display:flex;align-items:center;justify-content:center;
    transition:transform .22s var(--exp),border-color .22s var(--exp),background .22s var(--exp)}
  .hwa-fb-btn:hover{transform:translateY(-1px);border-color:var(--gold);background:var(--gold-soft)}
  .hwa-fb-btn:disabled{cursor:default;opacity:.45}
  .hwa-fb-btn.chosen{background:var(--gold-soft);border-color:var(--gold);opacity:1}
  .hwa-fb-thx{font-size:.76rem;color:var(--green-d);font-weight:500}

  .hwa-input{flex-shrink:0;padding:12px 14px 14px;background:#fff;border-top:1px solid var(--line);display:flex;gap:9px;align-items:flex-end}
  .hwa-input textarea{flex:1;border:1.5px solid var(--line);border-radius:25px;padding:14px 18px;font-family:inherit;font-size:1.02rem;
    resize:none;max-height:140px;line-height:1.45;background:var(--beige-2);color:var(--ink);transition:border-color .25s var(--exp),background .25s var(--exp)}
  .hwa-input textarea::placeholder{color:#6b655a}
  .hwa-input textarea:focus{outline:none;border-color:var(--gold);background:#fff}
  .hwa-send{width:48px;height:48px;flex-shrink:0;border:none;border-radius:50%;cursor:pointer;
    background:linear-gradient(135deg,var(--gold),var(--gold-d));box-shadow:0 4px 14px rgba(222,181,78,.46);
    display:flex;align-items:center;justify-content:center;transition:transform .25s var(--exp),opacity .25s var(--exp)}
  .hwa-send:hover{transform:translateY(-2px) scale(1.05)}.hwa-send:active{transform:scale(.96)}
  .hwa-send:disabled{opacity:.42;cursor:default;transform:none}
  .hwa-send svg{width:20px;height:20px;flex-shrink:0}
  .hwa-foot{text-align:center;font-size:.7rem;color:var(--ink-2);padding:0 0 9px;background:#fff;flex-shrink:0}
  .hwa-foot b{color:var(--gold-d);font-weight:600}

  @media(max-width:600px){
    .hwa-widget{top:0;left:0;right:0;bottom:0;width:100vw;height:100vh;height:100dvh;max-width:100vw;max-height:100vh;max-height:100dvh;border-radius:0}
    .hwa-launcher{right:18px;width:68px;height:68px}.hwa-launcher svg{width:33px;height:33px}.hwa-tip{display:none}
    .hwa-lab{right:98px;width:calc(100vw - 130px);font-size:.9rem;padding:12px 52px 12px 16px}
    .hwa-lab .go{width:36px;height:36px}.hwa-lab .go svg{width:17px;height:17px}
  }
  @media (prefers-reduced-motion: reduce){
    .hwa-w *,.hwa-w *::before,.hwa-w *::after{animation-duration:.001ms !important;animation-iteration-count:1 !important;transition-duration:.001ms !important}
    .hwa-launcher .pulse{display:none}
  }
  `;
  var st=document.createElement('style'); st.setAttribute('data-hwa-style',''); st.textContent=CSS; document.head.appendChild(st);

  // ---------- DOM ----------
  var wrap=document.createElement('div'); wrap.className='hwa-w';
  wrap.innerHTML=`
    <div class="hwa-tip" id="hwaTip"><span class="x">×</span>Hallo! 🌿 Hast Du eine <b>Frage</b>? Ich helf Dir gern weiter.</div>
    <div class="hwa-lab" id="hwaLab" role="button" aria-label="Chat öffnen"><span class="txt"></span><span class="go"><svg viewBox="0 0 24 24" fill="none"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="x" aria-label="Ausblenden">×</span></div>
    <button class="hwa-park" id="hwaPark" aria-label="Chat in die Ecke stellen" title="Chat in die Ecke stellen">×</button>
    <button class="hwa-launcher" id="hwaLauncher" aria-label="Chat öffnen">
      <span class="pulse"></span>
      <svg viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    <div class="hwa-widget" id="hwaWidget" role="dialog" aria-modal="true" aria-label="Heilwissen Akademie Chat">
      <div class="hwa-head">
        <div class="hwa-head-top">
          <img class="hwa-avatar sun" id="hwaHeadAva" src="${SUN}" alt="">
          <div class="hwa-head-meta"><h3 id="hwaHeadName">Heilwissen Akademie Bot</h3>
            <div class="status"><span class="dot"></span><span id="hwaHeadStatus">KI-Assistent, antwortet sofort</span></div></div>
          <div class="hwa-actions">
            <button class="hwa-iconbtn" id="hwaRestart" aria-label="Gespräch neu starten" title="Gespräch neu starten">
              <svg viewBox="0 0 24 24" fill="none"><path d="M3 12a9 9 0 1 0 3-6.7M3 4v4h4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
            <button class="hwa-iconbtn" id="hwaClose" aria-label="Schließen" title="Schließen">
              <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>
          </div>
        </div>
        <div class="hwa-persona" id="hwaPersona" data-p="assistant"><span class="pill"></span>
          <button data-persona="assistant" class="active">💬 Assistent</button>
          <button data-persona="rainer"><img class="ava" src="${RAINER_IMG}" alt="">Rainer persönlich</button>
        </div>
      </div>
      <div class="hwa-scroll">
        <div class="hwa-msgs" id="hwaMsgs" role="log" aria-live="polite" aria-relevant="additions"></div>
        <button class="hwa-tobottom" id="hwaToBottom" aria-label="Nach unten">
          <svg viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
      </div>
      <div class="hwa-quick" id="hwaQuick"></div>
      <div class="hwa-input">
        <textarea id="hwaText" rows="1" placeholder="Stelle deine Frage…" aria-label="Nachricht"></textarea>
        <button class="hwa-send" id="hwaSend" aria-label="Senden">
          <svg viewBox="0 0 24 24" fill="none"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
      <div class="hwa-foot">KI-Assistent mit Wissen aus der <b>Heilwissen Akademie</b>. Kann Fehler machen.</div>
    </div>`;
  document.body.appendChild(wrap);

  // ---------- Refs ----------
  var $=function(id){return wrap.querySelector(id);};
  var msgs=$('#hwaMsgs'), quick=$('#hwaQuick'), ta=$('#hwaText'), send=$('#hwaSend'),
      personaBar=$('#hwaPersona'), headAva=$('#hwaHeadAva'), headName=$('#hwaHeadName'),
      headStatus=$('#hwaHeadStatus'), launcher=$('#hwaLauncher'), widget=$('#hwaWidget'),
      tip=$('#hwaTip'), lab=$('#hwaLab'), park=$('#hwaPark'), toBottom=$('#hwaToBottom');
  var current=PERSONA_ORDER[0], busy=false, started={}, lastUser={};
  // Persona-Umschalter nur zeigen, wenn >1 Persona; Website = nur Assistent → Bar ausblenden
  if(PERSONA_ORDER.length<2) personaBar.style.display='none';

  // ---------- State / Persistenz ----------
  function sid(p){var k='hwa-chat-sid-'+p,v=localStorage.getItem(k);
    if(!v){v=p+'-'+Date.now().toString(36)+Math.random().toString(36).slice(2,8);localStorage.setItem(k,v);}return v;}
  function histKey(p){return 'hwa-chat-hist-'+p;}
  function loadHist(p){try{var d=JSON.parse(localStorage.getItem(histKey(p)));return (d&&d.v===2&&Array.isArray(d.m))?d.m:[];}catch(e){return [];}}
  function saveHist(p,arr){try{localStorage.setItem(histKey(p),JSON.stringify({v:2,m:arr.slice(-40)}));}catch(e){}}
  function pushHist(p,msg){var a=loadHist(p);a.push(msg);saveHist(p,a);}
  function resetSession(p){localStorage.removeItem(histKey(p));localStorage.removeItem('hwa-chat-sid-'+p);}

  // ---------- Markdown ----------
  function esc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  function mdInline(s){s=esc(s);
    s=s.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,'<a href="$2" target="_blank" rel="noopener">$1</a>');
    s=s.replace(/\*\*([^*]+)\*\*/g,'<strong>$1</strong>');
    s=s.replace(/(^|[^*])\*([^*]+)\*/g,'$1<em>$2</em>');return s;}
  function mdBlock(text){var lines=text.split(/\n/),html='',list=false;
    function cl(){if(list){html+='</ul>';list=false;}}
    for(var i=0;i<lines.length;i++){var ln=lines[i].replace(/\s+$/,'');
      var m=ln.match(/^\s*(?:[-*•]|\d+\.)\s+(.*)$/);
      if(m){if(!list){html+='<ul>';list=true;}html+='<li>'+mdInline(m[1])+'</li>';}
      else if(ln.trim()===''){cl();}else{cl();html+='<p>'+mdInline(ln)+'</p>';}}
    cl();return html;}

  // ---------- Produkt-Extraktion (Anker = …/products/-URL, robust) ----------
  function extractProducts(text){
    var linkRe=/\[([^\]]+)\]\((https?:\/\/[^)\s]*\/products\/[^)\s]+)\)/g,hits=[],lm;
    while((lm=linkRe.exec(text))!==null) hits.push({title:lm[1].replace(/[*_`]/g,'').trim(),url:lm[2].trim(),idx:lm.index});
    if(!hits.length) return null;
    // Dedup pro Produkt-Handle: nennt das Modell dasselbe Produkt mehrfach (Fließtext-Link + Karte),
    // darf nur EINE Karte entstehen — und sie übernimmt Preis+Bild von der Karten-Erwähnung.
    function keyOf(u){var m=u.match(/\/products\/([^/?#)]+)/);return m?m[1].toLowerCase():u.toLowerCase();}
    var byKey={},order=[];
    for(var i=0;i<hits.length;i++){
      var start=hits[i].idx,stop=(i+1<hits.length)?hits[i+1].idx:text.length,win=text.slice(start,stop);
      var pm=win.match(/([0-9]+(?:[.,][0-9]{2})?)\s*(?:EUR|€)/i),im=win.match(/!\[[^\]]*\]\((https?:\/\/[^)\s]+)\)/);
      var price=pm?(pm[1].replace('.',',')+' €'):'',img=im?im[1]:null,k=keyOf(hits[i].url);
      if(!(k in byKey)){byKey[k]={title:hits[i].title,url:hits[i].url,price:price,img:img};order.push(k);}
      else{var p=byKey[k];
        if(!p.img&&img){p.img=img;p.title=hits[i].title;if(price)p.price=price;} // Karten-Erwähnung gewinnt Titel+Bild
        else if(!p.price&&price){p.price=price;}}
    }
    var products=order.map(function(k){return byKey[k];});
    var prose=text
      .replace(/\[[^\]]*\]\(https?:\/\/[^)\s]*\/products\/[^)\s]+\)/g,'')
      .replace(/!\[[^\]]*\]\(https?:\/\/[^)\s]+\)/g,'')
      .replace(/Preis[:\s]*[0-9][0-9.,]*\s*(?:EUR|€)/gi,'')
      .replace(/[*_`]/g,'').split(/\n/)
      .map(function(s){return s.replace(/^\s*(?:\d+\.|[-*•])\s*/,'').trim();})
      .filter(function(s){return /[A-Za-zÄÖÜäöü0-9]/.test(s);}).join('\n').trim();
    return {products:products,prose:prose};
  }

  // ---------- Scroll ----------
  function nearBottom(){return msgs.scrollHeight-msgs.scrollTop-msgs.clientHeight<60;}
  function scroll(force){if(!force&&!nearBottom())return;var go=function(){msgs.scrollTop=msgs.scrollHeight;};
    requestAnimationFrame(go);setTimeout(go,150);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(go);}
  msgs.addEventListener('scroll',function(){toBottom.classList.toggle('show',!nearBottom());});

  // ---------- Render ----------
  function avatarHTML(){var p=PERSONA[current];return '<img class="mava'+(p.sun?' sun':'')+'" src="'+p.ava+'" alt="">';}
  function rowUser(text){var r=document.createElement('div');r.className='hwa-row user';
    r.innerHTML='<div class="hwa-bubble">'+esc(text).replace(/\n/g,'<br>')+'</div>';msgs.appendChild(r);scroll(true);}
  // Echte Bild-/Preis-Quelle: Shopify /products/{handle}.js (CORS-offen). Das Modell rät die Bild-URL
  // teils falsch → Karten holen featured_image deterministisch selbst am Handle. Fallback = geparster Wert.
  var SHOP_ORIGIN='https://shop.heilwissen-akademie.de';
  function handleOf(u){var m=(u||'').match(/\/products\/([^/?#)]+)/);return m?m[1]:'';}
  function hydrateCards(root){
    (root||msgs).querySelectorAll('.hwa-pcard[data-handle]').forEach(function(card){
      if(card._hy)return;var h=card.getAttribute('data-handle');if(!h)return;card._hy=1;
      fetch(SHOP_ORIGIN+'/products/'+encodeURIComponent(h)+'.js',{credentials:'omit'})
        .then(function(r){return r.ok?r.json():null;})
        .then(function(d){if(!d)return;
          var img=card.querySelector('.pimg img'),fi=d.featured_image||(d.images&&d.images[0]);
          if(img&&fi){img.src=(fi.indexOf('//')===0?'https:'+fi:fi);img.style.visibility='';}
          var pr=card.querySelector('.pprice');
          if(pr&&typeof d.price==='number'){pr.textContent=(d.price/100).toFixed(2).replace('.',',')+' €';pr.style.display='';}
        }).catch(function(){});
    });
  }
  function productsHTML(list){var box='<div class="hwa-products">';
    list.forEach(function(p,i){
      var img='<img alt="" loading="lazy"'+(p.img?(' src="'+p.img+'"'):'')+' onerror="this.style.visibility=\'hidden\'">';
      box+='<div class="hwa-pcard" data-handle="'+esc(handleOf(p.url))+'" style="animation-delay:'+(RM?0:i*70)+'ms"><div class="pimg">'+img
         +'<span class="pprice"'+(p.price?'':' style="display:none"')+'>'+esc(p.price||'')+'</span></div>'
         +'<div class="pbody"><p class="ptitle">'+esc(p.title)+'</p>'
         +'<a class="pbtn" href="'+p.url+'" target="_blank" rel="noopener">Zum Produkt →</a></div></div>';});
    return box+'</div>';}
  function rowProducts(list){var r=document.createElement('div');r.className='hwa-row bot';
    r.innerHTML='<div style="width:30px;flex-shrink:0"></div><div style="min-width:0;flex:1">'+productsHTML(list)+'</div>';
    msgs.appendChild(r);hydrateCards(r);scroll();}

  // bot-Bubble: optional Streaming-Reveal der Prosa, danach Produktkarten
  function rowBot(text,opts){opts=opts||{};
    var ex=extractProducts(text), prose=ex?ex.prose:text;
    var r=document.createElement('div');r.className='hwa-row bot';
    var holder=document.createElement('div');holder.style.maxWidth='84%';
    var bubble=document.createElement('div');bubble.className='hwa-bubble';
    if(ex&&!prose){holder.style.maxWidth='100%';} else {holder.appendChild(bubble);}
    r.innerHTML=avatarHTML();r.appendChild(holder);msgs.appendChild(r);
    // Produktkarten + Folge-Vorschläge SOFORT rendern — nie aufs Prosa-Streaming warten
    if(ex)rowProducts(ex.products);
    if(opts.then)opts.then();
    if(!prose){scroll();if(opts.done)opts.done();return;}
    if(opts.stream&&!RM&&prose.length<=700&&!document.hidden){
      streamText(bubble,prose,function(){bubble.innerHTML=mdBlock(prose);scroll();if(opts.done)opts.done();});
    } else {bubble.innerHTML=mdBlock(prose);scroll();if(opts.done)opts.done();}
  }
  function streamText(el,text,done){
    var toks=text.split(/(\s+)/),i=0;el.innerHTML='';
    var span=document.createElement('span');var caret=document.createElement('span');caret.className='hwa-caret';
    el.appendChild(span);el.appendChild(caret);
    var iv=setInterval(function(){
      span.textContent+=toks[i]||'';i++;
      if(i%4===0)scroll();
      if(i>=toks.length){clearInterval(iv);if(caret.parentNode)caret.remove();done();}
    },18);
  }

  // ---------- Feedback (👍/👎 → Notion via Webhook) ----------
  function addFeedback(question,answer){
    var r=document.createElement('div');r.className='hwa-fb';
    r.innerHTML='<span class="hwa-fb-q">War das hilfreich?</span>'
      +'<button class="hwa-fb-btn" data-r="up" aria-label="Hilfreich" title="Hilfreich">👍</button>'
      +'<button class="hwa-fb-btn" data-r="down" aria-label="Nicht hilfreich" title="Nicht hilfreich">👎</button>';
    msgs.appendChild(r);scroll();
    r.querySelectorAll('.hwa-fb-btn').forEach(function(btn){
      btn.onclick=function(){
        var rating=btn.dataset.r;
        r.querySelectorAll('.hwa-fb-btn').forEach(function(b){b.disabled=true;});
        btn.classList.add('chosen');
        try{fetch(FEEDBACK_URL,{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({sessionId:sid(current),persona:current,question:question,answer:answer,rating:rating})});}catch(e){}
        setTimeout(function(){r.innerHTML='<span class="hwa-fb-thx">Danke für dein Feedback! 🙏</span>';},220);
      };
    });
  }

  function showTyping(){var p=PERSONA[current];var r=document.createElement('div');r.className='hwa-row bot';r.id='hwaTyping';
    r.innerHTML=avatarHTML()+'<div class="hwa-typing"><div class="dots"><span></span><span></span><span></span></div><span class="lbl">'+esc(p.typingName||p.name)+' '+p.typing+'…</span></div>';
    msgs.appendChild(r);scroll(true);}
  function hideTyping(){var t=$('#hwaTyping');if(t)t.remove();}

  function renderChips(listGetter){quick.innerHTML='';listGetter().forEach(function(q){
    var c=document.createElement('button');c.className='hwa-chip';c.textContent=q;
    c.onclick=function(){ask(q);};quick.appendChild(c);});}
  function renderQuick(){renderChips(function(){return PERSONA[current].quick;});}
  function renderSuggest(){renderChips(function(){return PERSONA[current].suggest.filter(function(s){return s!==lastUser[current];});});}

  // ---------- Senden ----------
  function ask(text){if(busy||!text.trim())return;busy=true;send.disabled=true;quick.innerHTML='';
    lastUser[current]=text;
    rowUser(text);pushHist(current,{r:'u',t:text});ta.value='';ta.style.height='auto';showTyping();
    fetch(ENDPOINTS[current],{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({action:'sendMessage',sessionId:sid(current),chatInput:text,persona:current,
        pageUrl:location.href,site:location.hostname})})
      .then(function(r){return r.json();}).then(function(data){hideTyping();
        var out=Array.isArray(data)?(data[0]&&data[0].output):(data&&(data.output||data.text||data.message));
        out=out||"Entschuldige, da ist gerade etwas schiefgelaufen. Magst Du es nochmal versuchen?";
        var ex=extractProducts(out);pushHist(current,{r:'b',t:out,p:ex?ex.products:null});
        rowBot(out,{stream:true,done:function(){addFeedback(text,out);}});
      })
      .catch(function(){hideTyping();errorRow(text);})
      .finally(function(){busy=false;send.disabled=false;if(isOpen())ta.focus();});}

  function errorRow(retryText){var r=document.createElement('div');r.className='hwa-row bot';
    r.innerHTML=avatarHTML()+'<div class="hwa-bubble">Ich kann den Server gerade nicht erreichen. 🙏 <a href="#" id="hwaRetry">Nochmal versuchen</a></div>';
    msgs.appendChild(r);scroll(true);
    r.querySelector('#hwaRetry').onclick=function(e){e.preventDefault();r.remove();ask(retryText);};}

  // ---------- Persona / Verlauf ----------
  function renderHist(p){var h=loadHist(p);h.forEach(function(msg){
    if(msg.r==='u')rowUser(msg.t);
    else rowBot(msg.t,{}); });
    return h.length>0;}
  function bootPersona(){
    msgs.innerHTML='';
    rowBot(PERSONA[current].greet,{});            // Begrüßung immer frisch, NICHT gespeichert
    renderHist(current);                            // echte Turns wiederherstellen — keine Vorschlags-Chips mehr (Jannik: alle raus)
    started[current]=true;scroll(true);
  }
  function setPersona(p){if(p===current)return;current=p;personaBar.setAttribute('data-p',p);
    personaBar.querySelectorAll('button').forEach(function(b){b.classList.toggle('active',b.dataset.persona===p);});
    var cfg=PERSONA[p];headName.textContent=cfg.name;headStatus.textContent=cfg.status;
    headAva.src=cfg.ava;headAva.className='hwa-avatar'+(cfg.sun?' sun':'');
    bootPersona();}
  function restart(){resetSession(current);msgs.innerHTML='';started[current]=false;
    rowBot(PERSONA[current].greet,{});scroll(true);}

  // ---------- Öffnen / Schließen ----------
  function isOpen(){return document.body.classList.contains('hwa-open');}
  function open(){document.body.classList.add('hwa-open');hideTip();
    if(lab)lab.classList.remove('show');
    if(!started[current])bootPersona();
    setTimeout(function(){ta.focus();},430);var b=launcher.querySelector('.badge');if(b)b.style.display='none';}
  function close(){document.body.classList.remove('hwa-open');launcher.focus();}

  // ---------- Launcher-Gruß-Tooltip (1×/Session) ----------
  function hideTip(){tip.classList.remove('show');}
  function showTip(html){if(isOpen())return;
    tip.innerHTML='<span class="x">×</span>'+html;tip.classList.add('show');
    clearTimeout(showTip._t);showTip._t=setTimeout(hideTip,9000);}
  function maybeTip(){try{if(sessionStorage.getItem('hwa-tip'))return;}catch(e){}
    showTip('Hallo! 🌿 Hast Du eine <b>Frage</b>? Ich helf Dir gern weiter.');
    try{sessionStorage.setItem('hwa-tip','1');}catch(e){}}

  // ---------- Ruhemodus: Chat bewusst in die Ecke stellen ----------
  // Anlass: Kundenmeldung vom 30.07.2026 („Ich brauche meine kleine Bildfläche für mich.
  // Ständig kreuzt der BOT auf. Bitte ermöglichen, dass ich ihn bewusst in die Ecke stelle.")
  // Die Wahl gilt dauerhaft (localStorage), nicht nur für die laufende Sitzung. Der Chat
  // bleibt über den kleinen Punkt jederzeit erreichbar, es geht also kein Weg zum Support verloren.
  function ruheAn(){try{return localStorage.getItem('hwa-ruhe')==='1';}catch(e){return false;}}
  function ruheSetzen(an){
    wrap.classList.toggle('hwa-ruhe',an);
    try{an?localStorage.setItem('hwa-ruhe','1'):localStorage.removeItem('hwa-ruhe');}catch(e){}
    launcher.setAttribute('aria-label',an?'Chat öffnen (in der Ecke abgelegt)':'Chat öffnen');
  }
  if(ruheAn())ruheSetzen(true);
  park.onclick=function(e){e.stopPropagation();ruheSetzen(true);if(lab)lab.classList.remove('show');hideTip();};

  // ---------- Fragen-Teaser am Launcher (Eingabefeld-Optik) ----------
  // Zeigt sich bei jedem Seitenaufruf (auffällig, Wunsch Rainer 03.07.), blendet sich aber nach
  // 9 Sekunden von selbst wieder aus - vorher blieb er bis zum Klick stehen und belegte auf
  // jeder Seite dauerhaft rund 324px Bildfläche. Das „×" versteckt ihn ab jetzt dauerhaft
  // statt nur für die laufende Sitzung. Ohne Teaser (LAUNCHER_LABEL='') greift der alte Gruß-Tip.
  if(LAUNCHER_LABEL && lab){
    lab.querySelector('.txt').textContent=LAUNCHER_LABEL;
    var labOff=false;
    try{labOff=localStorage.getItem('hwa-lab-x')==='1'||sessionStorage.getItem('hwa-lab-x')==='1';}catch(e){}
    if(!labOff && !ruheAn()){
      setTimeout(function(){if(!isOpen()&&!ruheAn())lab.classList.add('show');},1300);
      setTimeout(function(){lab.classList.remove('show');},10300);
    }
    lab.onclick=function(e){
      if(e.target.classList.contains('x')){lab.classList.remove('show');try{localStorage.setItem('hwa-lab-x','1');}catch(_){}return;}
      open();};
  } else if(!RM){ setTimeout(maybeTip,3800); }

  // ---------- Events ----------
  launcher.onclick=open;
  tip.onclick=function(e){if(e.target.classList.contains('x')){hideTip();return;}open();};
  $('#hwaClose').onclick=close;
  $('#hwaRestart').onclick=restart;
  toBottom.onclick=function(){scroll(true);};
  send.onclick=function(){ask(ta.value);};
  personaBar.querySelectorAll('button').forEach(function(b){b.onclick=function(){setPersona(b.dataset.persona);};});
  ta.addEventListener('keydown',function(e){if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();ask(ta.value);}});
  ta.addEventListener('input',function(){ta.style.height='auto';ta.style.height=Math.min(ta.scrollHeight,140)+'px';});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&isOpen())close();});

  // ---------- Position: Sticky-Warenkorb + Cookie-Knopf ausweichen ----------
  // Selbst-erkennend, kein Config noetig. Angehoben wird nur, wenn unten rechts wirklich
  // etwas steht: ein SICHTBARER Sticky-Warenkorb (Kaching) hebt auf 134/100px, ein fixer
  // Cookie-Consent-Knopf unten rechts (z. B. Complianz) hebt zusaetzlich an, damit
  // Launcher und Teaser nichts ueberlappen. Ergebnis landet in der CSS-Variable --hwa-b.
  // Aenderung 11.09.2026: frueher reichte der Hostname shop.* als Grund fuer den Hub. Der
  // goldene Schwebe-Warenkorb ist aber seit dem 03.09.2026 sitewide ausgeblendet, der Chat
  // schwebte seitdem ohne Grund 134px ueber dem Rand. Rainer hat das im Call am 10.09.
  // angesprochen, der Warenkorb bleibt oben im Kopf. Jetzt entscheidet die Sichtbarkeit.
  function cookieRect(){
    var els=document.querySelectorAll('.cmplz-manage-consent,[id*="manage-consent"],[class*="manage-consent"],.cky-btn-revisit-wrapper');
    for(var i=0;i<els.length;i++){var el=els[i];
      try{var cs=getComputedStyle(el);
        if(cs.position!=='fixed'||cs.display==='none'||cs.visibility==='hidden')continue;
        var rc=el.getBoundingClientRect();
        if(rc.width<10||rc.height<10)continue;
        if(window.innerHeight-rc.bottom<120 && window.innerWidth-rc.right<240)return rc;
      }catch(e){}}
    return null;
  }
  // Nur ein wirklich gemalter Schwebe-Warenkorb zaehlt: vorhanden, sichtbar, mit Flaeche.
  function warenkorbUnten(){
    var els=document.querySelectorAll('[class*="kaching-cart__sticky"],[class*="sticky-cart"]');
    for(var i=0;i<els.length;i++){var el=els[i];
      try{var cs=getComputedStyle(el);
        if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)===0)continue;
        var rc=el.getBoundingClientRect();
        if(rc.width<10||rc.height<10)continue;
        return true;
      }catch(e){}}
    return false;
  }
  function applyOffsets(){
    var mob=window.innerWidth<=600;
    var hasCart = warenkorbUnten();
    var b=hasCart?(mob?100:134):(mob?18:26);
    var rc=cookieRect();
    if(rc){var lift=Math.round(window.innerHeight-rc.top)+10;if(lift>b)b=lift;}
    wrap.classList.toggle('hwa-cart',hasCart);
    wrap.style.setProperty('--hwa-b',b+'px');
  }
  var _oT;function queueOffsets(){clearTimeout(_oT);_oT=setTimeout(applyOffsets,180);}

  // ---------- Warenkorb-Schutz: im Kauf-Moment ist das Widget im Weg ----------
  // Kaching setzt bei offenem Warenkorb 'kaching-body__cart-open' auf html UND body; die Warenkorbseite
  // hat 'template-cart'. Der eigentliche Shopify-Checkout laedt das Widget ohnehin nicht.
  function cartOpen(){
    var cls=' '+document.documentElement.className+' '+(document.body?document.body.className:'')+' ';
    return / kaching-body__cart-open | template-cart /.test(cls) ||
           /^\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname);
  }
  // Cookie-Banner: liegt mobil im selben Eck wie Launcher und Teaser, das Widget deckte die
  // Zustimmen-Schaltflaeche zu. Solange das Banner steht, hat es Vorrang.
  function consentOffen(){
    var b=document.getElementById('shopify-pc__banner');
    if(!b) return false;
    try{var cs=getComputedStyle(b);
      return cs.display!=='none'&&cs.visibility!=='hidden'&&b.getBoundingClientRect().height>60;
    }catch(e){return false;}
  }
  function applyCartGuard(){
    var hide=cartOpen()||consentOffen();
    document.documentElement.classList.toggle('hwa-nocart',hide);
    if(hide&&isOpen())document.body.classList.remove('hwa-open'); // ohne focus(), Launcher ist dann unsichtbar
  }
  applyCartGuard();
  try{
    var _cartMO=new MutationObserver(applyCartGuard);
    _cartMO.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
    _cartMO.observe(document.body,{attributes:true,attributeFilter:['class']});
  }catch(e){}
  // Das Cookie-Banner verschwindet immer durch einen Klick, danach darf das Widget zurueck.
  document.addEventListener('click',function(){setTimeout(applyCartGuard,350);},true);
  setTimeout(applyCartGuard,1500); setTimeout(applyCartGuard,3500); setTimeout(applyCartGuard,8000);

  applyOffsets();
  setTimeout(applyOffsets,1500); setTimeout(applyOffsets,3500); setTimeout(applyOffsets,8000);
  window.addEventListener('resize',queueOffsets);
  try{
    var _posMO=new MutationObserver(queueOffsets);
    _posMO.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){_posMO.disconnect();},12000);
  }catch(e){}
})();
